export const addHappinessGraphStatus = count => ({
    type: 'ADD_HAPPINESS_GRAPH_STATUS',
    count
  })